/* @jsx h */

import { useEffect } from 'preact/hooks';
import { labels } from '../config';

const Pagination = ({
  pagination,
  triggerLoadMore,
  pluginNamespace,
  paginationInputEl,
}) => {
  useEffect(() => {
    if (paginationInputEl && paginationInputEl.current) {
      paginationInputEl.current.value = '';
    }
  }, []);

  function handleLoadMoreClick(event) {
    event && event.preventDefault();
    if (paginationInputEl && paginationInputEl.current) {
      paginationInputEl.current.value = pagination.currentPage + 1;
      triggerLoadMore();
    }
  }

  /* Only show load more button, if there is something to load */
  if (
    pagination
    && (pagination.currentPage === pagination.numberOfPages
      || pagination.numberOfPages === 0)
  ) {
    return '';
  }

  return (
    <div className="search-result__load-more">
      <button
        className="styled-button styled-button--load-more"
        type="button"
        onClick={handleLoadMoreClick}
      >
        <span className="styled-button__text">
          {labels.pagination.loadMore}
        </span>
      </button>
    </div>
  );
};

export default Pagination;
